import { Box, Typography } from '@mui/material';
import { useLanguage } from '../context/LanguageContext';
import { getText } from '../utils/translations';
import TranslatedText from './TranslatedText';

const FormInput = ({
  type = 'text',
  id,
  name,
  value,
  onChange,
  required = false,
  placeholder,
  labelTextId,
  icon,
  error = false,
  errorMessage,
  ...props
}) => {
  const { language } = useLanguage();
  
  return (
    <Box sx={{ mb: 3 }}>
      <Typography 
        variant="subtitle1" 
        component="label" 
        htmlFor={id}
        sx={{ 
          display: 'block', 
          mb: 1,
          fontWeight: 600
        }}
      >
        <TranslatedText textId={labelTextId} />
      </Typography>
      <Box 
        sx={{ 
          display: 'flex',
          alignItems: 'center',
          p: 1.5,
          border: '1px solid',
          borderColor: error ? 'error.main' : 'rgba(0, 0, 0, 0.23)',
          borderRadius: 1,
          transition: 'all 0.2s',
          '&:focus-within': {
            borderColor: error ? 'error.main' : 'primary.main',
            boxShadow: error 
              ? '0 0 0 2px rgba(211, 47, 47, 0.2)' 
              : '0 0 0 2px rgba(25, 118, 210, 0.2)'
          }
        }}
      >
        {icon && (
          <Box 
            component="span" 
            sx={{ 
              mr: 1.5, 
              color: error ? 'error.main' : 'text.secondary',
              display: 'flex'
            }}
          >
            {icon}
          </Box>
        )}
        <input
          type={type}
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          required={required}
          style={{ 
            width: '100%', 
            padding: '4px', 
            border: 'none',
            outline: 'none',
            fontSize: '16px',
            backgroundColor: 'transparent' 
          }}
          placeholder={placeholder || getText(id, language)}
          {...props}
        />
      </Box>
      {error && errorMessage && (
        <Typography 
          variant="caption" 
          sx={{ 
            color: 'error.main',
            display: 'flex',
            alignItems: 'center',
            mt: 1
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16" style={{marginRight: '4px'}}>
            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
          </svg>
          {errorMessage}
        </Typography>
      )}
    </Box>
  );
};

export default FormInput; 